import {
  LayoutDashboard,
  CalendarCheck,
  Users,
  Wrench,
  CreditCard,
  BarChart3,
  MessageSquare,
  Package,
  UserCog,
  Crown,
  Layers,
  IndianRupee,
  Boxes,
  Tag,
  RotateCcw,
  MessageCircle,
  ClipboardCheck,
  ShieldCheck,
  ClipboardList,
  Activity,
  Car,
  MapPin,
  ConciergeBell,
  BookOpen,
  HelpCircle,
  Handshake,
  KeyRound,
  UserPlus,
  Wallet,
} from "lucide-react";

// Sidenav link definitions for each panel variant, kept in a plain config
// file (rather than inside Sidebar.jsx) so it can also be imported by
// non-component code — e.g. Frontend/src/utils/adminAccess.js uses
// ADMIN_LINKS to compute a fallback landing path for module-level RBAC.
export const ADMIN_LINKS = [
  { label: "Dashboard", to: "/admin", icon: LayoutDashboard, end: true, moduleKey: "dashboard" },
  { label: "Walk-in Booking", to: "/admin/assisted-booking", icon: ConciergeBell, moduleKey: "bookings" },
  { label: "Bookings", to: "/admin/bookings", icon: CalendarCheck, moduleKey: "bookings" },
  { label: "Leads", to: "/admin/leads", icon: UserPlus, moduleKey: "leads" },
  { label: "Booking Accounts", to: "/admin/booking-accounts", icon: Wallet, moduleKey: "booking_accounts" },
  { label: "Users", to: "/admin/users", icon: Users, moduleKey: "users" },
  { label: "Technicians", to: "/admin/technicians", icon: UserCog, moduleKey: "technicians" },
  { label: "Channel Partners", to: "/admin/channel-partners", icon: Handshake, moduleKey: "channel_partners" },
  { label: "Settlements", to: "/admin/settlements", icon: IndianRupee, moduleKey: "settlements" },
  { label: "Categories", to: "/admin/categories", icon: Layers, moduleKey: "categories" },
  { label: "Packages", to: "/admin/packages", icon: Wrench, moduleKey: "packages" },
  { label: "Pricing", to: "/admin/pricing", icon: IndianRupee, moduleKey: "car_master" },
  { label: "Inventory", to: "/admin/inventory", icon: Boxes, moduleKey: "inventory" },
  { label: "Part Categories", to: "/admin/inventory-categories", icon: Tag, moduleKey: "inventory" },
  { label: "Car Master", to: "/admin/car-master", icon: Car, moduleKey: "car_master" },
  { label: "Location Master", to: "/admin/location-master", icon: MapPin, moduleKey: "location_master" },
  { label: "Coupons", to: "/admin/coupons", icon: Tag, moduleKey: "coupons" },
  { label: "Blog", to: "/admin/blog", icon: BookOpen, moduleKey: "blog" },
  { label: "FAQs", to: "/admin/faq", icon: HelpCircle, moduleKey: "faq" },
  { label: "Plans", to: "/admin/plans", icon: Crown, moduleKey: "plans" },
  { label: "Subscriptions", to: "/admin/subscriptions", icon: Package, moduleKey: "subscriptions" },
  { label: "Complaints", to: "/admin/complaints", icon: MessageSquare, moduleKey: "complaints" },
  { label: "Payments", to: "/admin/payments", icon: CreditCard, moduleKey: "payments" },
  { label: "Refunds", to: "/admin/refunds", icon: RotateCcw, moduleKey: "refunds" },
  { label: "WhatsApp", to: "/admin/whatsapp", icon: MessageCircle, moduleKey: "whatsapp" },
  { label: "Warranty Claims", to: "/admin/warranty-claims", icon: ShieldCheck, moduleKey: "warranty_claims" },
  { label: "Warranty Lookup", to: "/admin/warranty", icon: ShieldCheck, moduleKey: "warranty_claims" },
  { label: "RR Requests", to: "/admin/rr", icon: Wrench, moduleKey: "rr" },
  { label: "Revenue", to: "/admin/revenue", icon: BarChart3, moduleKey: "reports" },
  { label: "Operations", to: "/admin/reports/operations", icon: ClipboardList, moduleKey: "reports_operations" },
  { label: "Activity Log", to: "/admin/audit", icon: Activity, moduleKey: "audit" },
  { label: "Role Management", to: "/admin/roles", icon: KeyRound, moduleKey: "roles" },
];

export const TECH_LINKS = [
  { label: "Dashboard", to: "/technician", icon: LayoutDashboard, end: true },
  { label: "My Jobs", to: "/technician/jobs", icon: CalendarCheck },
  { label: "Attendance", to: "/technician/attendance", icon: ClipboardCheck },
  { label: "Warranty", to: "/technician/warranty", icon: ShieldCheck },
  { label: "Profile", to: "/technician/profile", icon: UserCog },
];

export const PARTNER_LINKS = [
  { label: "Dashboard", to: "/partner", icon: LayoutDashboard, end: true },
  { label: "My Jobs", to: "/partner/jobs", icon: CalendarCheck, moduleKey: "BOOKINGS" },
  { label: "Settlements", to: "/partner/settlements", icon: IndianRupee, moduleKey: "SETTLEMENTS" },
  { label: "Warranty Lookup", to: "/partner/warranty", icon: ShieldCheck, moduleKey: "WARRANTY_LOOKUP" },
  { label: "Profile", to: "/partner/profile", icon: UserCog },
];
